import React from 'react';
import {RTEDialog} from './EditorDialog';
import {CustomQueryClientProvider} from '../../hooks/useQueryClientProvider';

export const EditorProvider = () => (
    <CustomQueryClientProvider>
        <RTEDialog />
    </CustomQueryClientProvider>
);

export default EditorProvider;
